import { useEffect, useState } from 'react';
import l from '../../../../lang';
import './styles.scss';
import Tabs from '../../../common/tabs';
import TopDashboardSection from '../../../common/top-dashboard-section';
import Card from '../../../common/card';
import CardDescription from '../../../common/card-description';
import AlertMessages from '../../alert-messages';
import Affiliations from './affiliations';
import Benefits from './benefits';

const AffiliationsHome = () => {
  const [tabSelected, setTabSelected] = useState(0);
  const tabsIndexes = ['affiliations', 'benefits'];

  const changeUrlTab = (idx: number) => {
    const url = new URL(window.location.href);
    url.searchParams.set('tab', tabsIndexes[idx]);
    window.history.pushState({}, '', url);
  };

  useEffect(() => {
    const url = new URL(window.location.href);
    const tab = url.searchParams.get('tab');
    const idx = tabsIndexes.indexOf(tab || '');
    if (idx !== -1) {
      setTabSelected(idx);
    }
  }, []);

  return (
    <div className="affiliations">
      <TopDashboardSection title={l('menu.item.AFFILIATIONS')} subtitle={l('menu.item.AFFILIATIONS.desc')} />
      <AlertMessages />
      <Card>
        <CardDescription>
          <Tabs
            id="affiliations-tabs"
            idxItemSelected={tabSelected}
            items={[
              {
                title: l('menu.item.AFFILIATIONS'),
                content: <Affiliations />,
              },
              {
                title: l('affiliations.benefits'),
                content: <Benefits />,
              },
            ]}
            onChange={idx => {
              setTabSelected(idx);
              changeUrlTab(idx);
            }}
          />
        </CardDescription>
      </Card>
    </div>
  );
};

export default AffiliationsHome;
